module.exports = __webpack_public_path__ + "img/human village.ec5085c3.png";